import React from "react";
import { Layout } from "@/components/Layout";
import { PageHero } from "@/components/common";
import { useSEO } from "@/lib/useSEO";
import { CONTACT } from "@/config/site";

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="font-display text-xl font-bold text-slate-900">{title}</h2>
    <div className="mt-3 space-y-3 text-sm leading-relaxed text-slate-600">{children}</div>
  </div>
);

export default function Cookie() {
  useSEO({ title: "Cookie Policy | Atmasamman Group", description: "How Atmasamman Group uses cookies and similar technologies on its website.", path: "/cookie-policy" });
  return (
    <Layout>
      <PageHero eyebrow="Legal" title="Cookie Policy" subtitle="This policy explains how we may use cookies and similar technologies on our website." />
      <section className="py-16 md:py-24">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
          <Section title="What Are Cookies">
            <p>Cookies are small text files stored on your device that help websites function and understand how visitors interact with them.</p>
          </Section>
          <Section title="How We Use Cookies">
            <p>We may use cookies to keep the website functioning correctly and, where enabled, to understand aggregate usage through analytics tools. Analytics are only activated once configured with valid identifiers.</p>
          </Section>
          <Section title="Managing Cookies">
            <p>Most browsers allow you to control or delete cookies through their settings. Disabling cookies may affect certain website features.</p>
          </Section>
          <Section title="Contact Us">
            <p>For questions about this cookie policy, contact us at <a href={`mailto:${CONTACT.primaryEmail}`} className="font-medium text-orange-600 hover:underline">{CONTACT.primaryEmail}</a>.</p>
          </Section>
        </div>
      </section>
    </Layout>
  );
}
